import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
import 'tippy.js/animations/shift-away.css';
import 'tippy.js/themes/material.css';

const _s = {
    tippy: '[data-tippy-content]',
}

export class toolTip {
    constructor() {
        this.initTippy();
        this.ajaxCallback();
    }

    initTippy() {
        tippy(_s.tippy, {
            allowHTML: true,
            animation: 'shift-away',
            theme: 'material',
            interactive: true,
        });
    }

    ajaxCallback() {
        $(document).ajaxComplete((event, xhr, settings) => {
            if (settings.url.includes('wp-admin/admin-ajax.php')) {
                this.initTippy();
            }
        });
    }
}